import {useMemo} from 'react'

import {MonaFooter as WebGLMonaFooter} from '../../../../../brand/components/MonaFooter/MonaFooter'

import Styles from './MonaFooter.module.css'

export interface FeaturedRepository {
  nameWithOwner: string
  description: string | null
  url: string
  newStars: number
}

export interface MonaFooterProps {
  mona: {
    variant: 'dark' | 'purple'
  }
  repos: {
    items: FeaturedRepository[]
    starsTemplate: string
  }
}

export const defaultProps: Partial<MonaFooterProps> = {}

export const MonaFooter = (props: MonaFooterProps) => {
  const initializedProps: MonaFooterProps = {...defaultProps, ...props}
  const {mona, repos} = initializedProps
  const artworkProps = useMemo(
    () => ({
      mona: {...mona, alt: ''},
      repos: {...repos, starsTemplate: repos.starsTemplate.replaceAll('{newStars}', '{count}')},
    }),
    [mona, repos],
  )

  return (
    <div className={Styles['MonaFooter']}>
      <WebGLMonaFooter {...artworkProps} />
    </div>
  )
}
